import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledBadge = styled.div`
  height: 24px;
  padding: 0px 8px;
  margin-left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:first-of-type {
    margin-left: 16px;
  }

  border-radius: 12px;
  background-color: ${({ theme: { colors }, variant }) => (variant === 'primary' ? colors.mainColorContrast : colors.backgroundColorWhite)};
  border: 2px solid ${({ theme }) => theme.colors.mainColorContrast};

  color: ${({ theme: { colors }, variant }) => (variant === 'primary' ? colors.backgroundColorWhite : colors.mainColorContrast)};
  ${({ theme }) => theme.typograph.descriptionRegular};
  text-transform: uppercase;
`;

const Badge = ({ text, variant }) => (
  <StyledBadge variant={variant}>
    {text}
  </StyledBadge>
);

Badge.propTypes = {
  text: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary']),
};

Badge.defaultProps = {
  variant: 'primary',
};

export default Badge;
